import styled from 'styled-components';

export const HourLabel = styled.span`
  display: block;
  margin-top: ${(props) => props.theme.config.spacing.spacing_1};
  color: ${(props) => props.theme.config.colors.gray_400};
  ${(props) => props.theme.config.typograph.mico};
`;
